import { Component, OnInit, ViewChild, Input, ElementRef } from "@angular/core"; import { Location } from "@angular/common";
import { Table } from 'primeng/table';
import { BreadcrumbService } from '../../app.breadcrumb.service';

import { RequisitionService } from '../../services/requisition-service';
import { RequisitionMin } from '../../entites/requisition-min';
import { MenuItem } from 'primeng/api/menuitem';
import { MessageService, LazyLoadEvent, ConfirmationService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

import { DialogService } from 'primeng/dynamicdialog';
import { EnvoiRequisitionComponent } from '../../controles/envoi-requisition.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ListeAchatService } from 'src/app/services/liste-achat-service';
import { Emplacement } from 'src/app/entites/emplacement';
import { EmployeEntite } from 'src/app/entites/employe';
import { EmplacementService } from 'src/app/services/emplacement-service';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { environment } from "src/environments/environment";
import { Map as MapboxMap, Marker, Popup } from 'mapbox-gl';
import { EStatuts } from "src/app/entites/enums/statuts";
import mapboxgl from "mapbox-gl";

@Component({
    templateUrl: './emplacements.component.html',
    styleUrls: ['./emplacements.component.scss'],
    styles: [`
        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService, DialogService]
})
export class EmplacementsComponent extends BaseComponent implements OnInit {

    emplacements: Emplacement[];
    selectionEmplacement: Emplacement;

    dialogueNouvelEmplacement = false;
    submitted = false;
    nouvelEmplacement: Emplacement;
    chargementCompleteMap = false;

    map: MapboxMap;
    marker: Marker;
    markers: Marker[] = [];
    mapCenter: [number, number] = [-71.2080, 46.8139]; // Default center (Quebec City)
    
    // Store mapping between emplacements and their markers
    emplacementMarkerMap: Map<number, Marker> = new Map();

    @ViewChild('map') mapElement: ElementRef;
    @ViewChild('champRecherche') inputRecherche;
    @ViewChild('dt') table: Table;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent, location: Location,
        private breadcrumbService: BreadcrumbService,
        private emplacementService: EmplacementService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router) {
        super(sdb, profilService, route, routerService, appMain);
        this.breadcrumbService.setItems([
            { label: 'Emplacements' }
        ]);
    }

    ngOnInit() {



        this.verifierAccesPage('emplacements');

        this.emplacements = this.sdb.EmplacementsComplet();


        if (this.profilService.Profil().roles.find(x => x.nom == 'SIHC_ChargeProjet')) {
            if (this.profilService.Profil().employe.emplacementIdsCP) {
                this.emplacements = this.sdb.EmplacementsComplet().filter(x => this.profilService.Profil().employe.emplacementIdsCP.includes(x.emplacementId));
            } else {
                this.emplacements = [];
            }
        } else {
            this.emplacements = this.sdb.EmplacementsComplet();
        }

        this.initMap();
    }

    surEntreeRecherche() {

        if (this.table.filteredValue != undefined &&
            this.table.filteredValue.length == 1) {
            this.OuvrirDetail(this.table.filteredValue[0].emplacementId);
        }

    }

    OuvrirDetail(emplacementId: number) {
        this.routerService.navigateByUrl(`emplacement/${emplacementId}`)
    }

    surAjoutEmplacement() {
        this.nouvelEmplacement = { emplacementId: 0 };
        this.dialogueNouvelEmplacement = true;
    }

    creerNouvelEmplacement() {

        //this.dialogueNouvelItem = false;
        //this.routerService.navigateByUrl('item/595');
        this.submitted = true;
        this.messageService.clear("nouvelEmplacement");

        if (this.validerNouvelEmplacement()) {

            this.emplacementService.AjouterEmplacement(this.nouvelEmplacement).then(x => {
                console.log(x);
                if (x.estUnSucces) {
                    this.routerService.navigateByUrl('emplacement/' + x.valeur.emplacementId);
                } else {
                    x.messages.forEach(x => {
                        this.messageService.add({ key: "nouvelEmplacement", severity: 'error', summary: 'Erreur', detail: x.description, sticky: true });
                    });
                }
            });
        }
    }

    validerNouvelEmplacement(): boolean {
        if (!this.nouvelEmplacement.code || !this.nouvelEmplacement.nom) {
            return false;
        }

        return true;
    }

    annulerNouvelEmplacement() {
        this.dialogueNouvelEmplacement = false;
    }

    initMap() {
        setTimeout(() => {
            this.mapElement.nativeElement.style.filter = 'blur(4px)';
            this.map = new MapboxMap({
                container: this.mapElement.nativeElement,
                style: 'mapbox://styles/adminhc/cm6p7rhpi001v01qogqiq9wbj',
                zoom: 7,
                center: this.mapCenter,
                pitch: 35,
                bearing: 0,
                accessToken: environment.mapbox.accessToken
            });
            setTimeout(() => {
                this.updateMapMarker();
            }, 500);
        }, 500);
    }

    updateMapMarker() {
        // Create an array to store all coordinates for bounds calculation
        const bounds = new mapboxgl.LngLatBounds();

        this.emplacements.filter(x => x.adresse && x.adresse.municipalite && x.adresse.province && x.adresse.codePostal && x.statut.statutId == EStatuts.Actif).forEach(emplacement => {
            const address = `${emplacement.adresse.numero} ${emplacement.adresse.rue}, ${emplacement.adresse.municipalite}, ${emplacement.adresse.province}, ${emplacement.adresse.codePostal}`;

            fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=${environment.mapbox.accessToken}`)
                .then(response => response.json())
                .then(data => {
                    if (data.features && data.features.length > 0) {
                        const coordinates = data.features[0].center;
                        // Add coordinates to bounds array
                        bounds.extend(coordinates);

                        const popup = new Popup({ 
                            offset: 25,
                            closeButton: false,
                            className: 'emplacement-popup'
                        }).setHTML(`
                            <div class="emplacement-popup-content">
                                <div class="popup-header">
                                    <h4 class="popup-title">${emplacement.nom}</h4>
                                    <span class="popup-code">${emplacement.code}</span>
                                </div>
                                <div class="popup-body">
                                    ${emplacement.statut ? `
                                    <div class="popup-info-row">
                                        <i class="pi pi-info-circle"></i>
                                        <span class="popup-status ${emplacement.statut.nom.replace(' ','').toLowerCase()}">${emplacement.statut.nom}</span>
                                    </div>
                                    ` : ''}
                                    ${emplacement.nombreDocuments ? `
                                    <div class="popup-info-row">
                                        <i class="pi pi-file"></i>
                                        <span>${emplacement.nombreDocuments} document${emplacement.nombreDocuments > 1 ? 's' : ''}</span>
                                    </div>
                                    ` : ''}
                                </div>
                                <div class="popup-footer">
                                    <a href="/emplacement/${emplacement.emplacementId}" class="popup-link">
                                        <i class="pi pi-eye"></i> Voir détails
                                    </a>
                                </div>
                            </div>
                        `);

                        const marker = new Marker({
                            color: '#00843D',
                        }).setLngLat(coordinates);

                        popup.on('mouseenter', () => {
                            console.log('mouseenter');
                            this.OuvrirDetail(emplacement.emplacementId);
                        });

                        marker.setPopup(popup); // Attach popup to marker
                        marker.addTo(this.map);
                        this.markers.push(marker);
                        
                        // Store the mapping between emplacement ID and marker
                        this.emplacementMarkerMap.set(emplacement.emplacementId, marker);

                        if (this.markers.length === this.emplacements.filter(x =>
                            x.adresse && x.adresse.municipalite && x.adresse.province &&
                            x.adresse.codePostal && x.statut.statutId == EStatuts.Actif).length) {
                            // Fit map to show all markers with padding
                            this.map.fitBounds(bounds, {
                                padding: { top: 50, bottom: 50, left: 50, right: 50 },
                                maxZoom: 15,
                                duration: 0 // Disable animation for immediate fit
                            });
                        }
                    }
                });
        });

        this.chargementCompleteMap = true;
        this.mapElement.nativeElement.style.filter = 'none';
        this.CompleterChargement();
    }

    // Method to handle table row hover - show popup
    onRowHover(emplacement: Emplacement) {
        const marker = this.emplacementMarkerMap.get(emplacement.emplacementId);
        if (this.marker) {
            this.marker.remove();
        }
        if (marker && marker.getPopup()) {
            marker.getPopup().addTo(this.map);
            this.marker = marker;
        }
    }
}
